exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-sort-icon svg {\n  height: 10px !important;\n}", ""]);

// exports
